import 'whatwg-fetch';

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import APIClient, {
  iterUnpack,
  defaultLogoImageUrl,
  prepareImgixParams,
} from '../../services/APIClient';
import SegmentClient from '../../services/SegmentClient';
import Alert from '../Alert';
import ShowMoreButton from '../ShowMoreButton';
import { ANALYTICS_NAME } from './Constants';

const BRAND_SLUG = document.getElementById('root').getAttribute('data-brand-slug');

const segment = new SegmentClient();

export default class BrandDetailFirms extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.defaultState();
  }

  UNSAFE_componentWillMount() {
    const props = iterUnpack(JSON.parse(window.props));
    const brand = props.allBrands[0];
    const newState = {
      isLoading: false,
      firmsUsingThisBrand: brand.firmsUsingThisBrand || [],
      firmsWithPlacementsCount: brand.firmsWithPlacementsCount,
    };

    if (props.metadata && props.metadata.firmsUsingThisBrand) {
      newState.metadata = props.metadata;
    }

    this.setState(newState);
  }

  getImageUrl = (media) => {
    if (media && media.length > 0) {
      return prepareImgixParams(media[0].mediaItem.url, { w: 22, h: 22, auto: 'format,compress' });
    }
    return defaultLogoImageUrl;
  }

  showMoreFirmsHandler = () => {
    segment.track(ANALYTICS_NAME.BRAND_SHOW_MORE_FIRMS_CLICKED);
    this.setState({ isLoading: true });
    const query = `{
      allBrands(slug: "${BRAND_SLUG}") {
        edges {
          node {
            firmsUsingThisBrand: firms(first: 15, after: "${this.state.metadata.firmsUsingThisBrand.endCursor}", orderBy: "-created") {
              edges {
                cursor
                node {
                  name
                  djangoId
                  id
                  media(first: 1, type: "${window.MEDIA_TYPE_LOGO}") {
                    ...mediaItem
                  }
                  url
                  slug
                }
              }
              pageInfo {
                endCursor
                hasNextPage
              }
            }
          }
        }
      }
    }
    fragment mediaItem on MediaItemAttributionNodeConnection {
      edges {
        node {
          type
          mediaItem {
            id
            square230
            url
            originalName
          }
        }
      }
    }`;

    // Fetch data from API using CSRF header
    if (this.state.metadata.firmsUsingThisBrand.hasNextPage) {
      APIClient(query, true)
        .then((data) => {
          const newFirms = data.allBrands[0].firmsUsingThisBrand;
          const firmsUsingThisBrand = Array.from(new Set([
            ...this.state.firmsUsingThisBrand,
            ...newFirms,
          ]));
          // Set state with fetched data, checking for emptiness on data.allBrands
          this.setState({
            firmsUsingThisBrand,
            metadata: data.metadata,
            isLoading: false,
          });
        });
    }
  };

  defaultState = () => ({
    firmsWithPlacementsCount: 0,
    firmsUsingThisBrand: [],
    metadata: {
      firmsUsingThisBrand: {
        hasNextPage: false,
        endCursor: 0,
      },
    },
  });

  render() {
    const {
      firmsUsingThisBrand, firmsWithPlacementsCount, isLoading, metadata,
    } = this.state;
    const emptyMessage = this.props.emptyMessage || 'No Firms Available';
    return (
      <div className="row">
        <h3 className="columns small-12 pb-base fs-m fw-medium">
          <i className="material-icons">location_city</i>
          {' '}
          Firms
        </h3>
        <div className="columns small-12">
          {firmsUsingThisBrand && firmsUsingThisBrand.length > 0
            ? (
              <>
                <div className="row small-up-1 medium-up-2 large-up-3 pb-xxs">
                  { firmsUsingThisBrand.map(({
                    id, djangoId, name, media, slug, url,
                  }) => (
                    <div className="column ellipsis pt-xs pb-xs" key={id}>
                      <a
                        onClick={() => segment.track(ANALYTICS_NAME.BRAND_FIRM_USING_BRAND_CLICKED,
                          { firm_name: name, firm_id: djangoId, firm_slug: slug })}
                        href={url}
                        className="black"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          alt={name}
                          src={this.getImageUrl(media)}
                          style={{
                            width: '22px',
                            height: '22px',
                            marginRight: '10px',
                          }}
                        />
                        <span>{name}</span>
                      </a>
                    </div>
                  ))}
                </div>
                <div className="row align-center pt-m">
                  <ShowMoreButton
                    showMoreHandler={this.showMoreFirmsHandler}
                    hasNextPage={metadata.firmsUsingThisBrand.hasNextPage}
                    isLoading={isLoading}
                    remainingItems={firmsWithPlacementsCount - firmsUsingThisBrand.length}
                    text="View More Firms"
                  />
                </div>
              </>
            )
            : (
              <Alert type="secondary">
                {emptyMessage}
              </Alert>
            )}
        </div>
        {!this.props.hideDivider
        && (
        <div className="columns small-12">
          <hr />
        </div>
        )}
      </div>
    );
  }
}

BrandDetailFirms.propTypes = {
  emptyMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  hideDivider: PropTypes.bool,
};

BrandDetailFirms.defaultProps = {
  emptyMessage: null,
  hideDivider: false,
};
